import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import history from "../../history";
import InputText from "../InputText";
import config from "../../utils/config";
import {
  ApproveRejectTestimonial,
  fetchTestimonialDetails,
} from "../../redux/Testimonials/action";
import CrossIcon from "../../assets/images/close_icon.svg";
import TickIcon from "../../assets/images/tick_icon.svg";
import { ApproveImage } from "../../redux/Testimonials/action";
import get from "lodash/get";

export default function TestimonialPersonalInfromation(props) {
  const _ = { get };
  const location = useHistory();
  const dispatch = useDispatch();
  const { elements } = useSelector((state) => state.Elements);
  const { usertype } = useSelector((state) => state.Auth);
  const { testimonialsDetailsData } = useSelector(
    (state) => state.Testimonials
  );
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectionReasonToggle, setRejectionReasonToggle] = useState(false);
  const [rejectImage, setRejectImage] = useState(false);
  const [previewImage, setPreviewImage] = useState(false);
  const [imageDetail, setImageDetail] = useState(null);

  useEffect(() => {
    if (
      testimonialsDetailsData === null ||
      testimonialsDetailsData._id !== location.location.search.split("=")[1]
    )
      dispatch(fetchTestimonialDetails(location.location.search.split("=")[1]));
  }, []);
  const handleApprove = () => {
    let obj = {
      testimonialId: testimonialsDetailsData._id,
      status: "APPROVED",
    };
    dispatch(ApproveRejectTestimonial(obj));
  };
  const handleReject = () => {
    setRejectionReasonToggle(!rejectionReasonToggle);
    let obj = {
      testimonialId: testimonialsDetailsData._id,
      status: "REJECTED",
      rejectionReason: rejectionReason,
    };
    setRejectionReason("");
    dispatch(ApproveRejectTestimonial(obj));
  };

  const handleGoBack = () => {
    history.push("/moderation/testimonials");
  };

  const handleApproveImage = () => {
    let obj = {
      testimonialId: testimonialsDetailsData._id,
      status: "APPROVED",
      assetId: testimonialsDetailsData.image._id,
    };
    dispatch(ApproveImage(obj, handleApproveRejectCallBack));
  };
  const handleRejectImage = () => {
    setRejectionReasonToggle(!rejectionReasonToggle);

    let obj = {
      testimonialId: testimonialsDetailsData._id,
      status: "REJECTED",
      rejectionReason: rejectionReason,
      assetId: testimonialsDetailsData.image._id,
    };
    setRejectionReason("");
    dispatch(ApproveImage(obj, handleApproveRejectCallBack));
  };

  const handleApproveRejectCallBack = () => {
    dispatch(fetchTestimonialDetails(location.location.search.split("=")[1]));
  };

  const handlePreviewImages = (e, image) => {
    setPreviewImage(!previewImage);
    setImageDetail(image);
  };
  return (
    <React.Fragment>
      <div className="hideSearch mt-4">
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={`${testimonialsDetailsData &&
                  testimonialsDetailsData.author} by ${testimonialsDetailsData &&
                  testimonialsDetailsData.createdBy &&
                  testimonialsDetailsData.createdBy.name}`}
                iconClass={"hideexcel"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            <CardBody>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.testimonialPersonalInfo.partnerDeatilHeadingElement",
                        "Partner Detail"
                      )}
                    </span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.testimonialPersonalInfo.nameLabel",
                      "Name"
                    )}
                    titleName={
                      testimonialsDetailsData &&
                      testimonialsDetailsData.createdBy &&
                      testimonialsDetailsData.createdBy.name
                        ? testimonialsDetailsData.createdBy.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.testimonialPersonalInfo.partnerDeatilHeadingElement",
                      "Email"
                    )}
                    titleName={
                      testimonialsDetailsData &&
                      testimonialsDetailsData.createdBy &&
                      testimonialsDetailsData.createdBy.email
                        ? testimonialsDetailsData.createdBy.email
                        : "N/A"
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.testimonialPersonalInfo.testimonialDetailHeadingElement",
                        "Testimonial Detail"
                      )}
                    </span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.testimonialPersonalInfo.riderNameLabel",
                      "Rider Name"
                    )}
                    titleName={
                      testimonialsDetailsData && testimonialsDetailsData.author
                        ? testimonialsDetailsData.author
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.testimonialPersonalInfo.riderLocationLabel",
                      "Rider Location"
                    )}
                    titleName={
                      testimonialsDetailsData &&
                      testimonialsDetailsData.location
                        ? testimonialsDetailsData.location
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.testimonialPersonalInfo.postedDateLabel",
                      "Posted Date"
                    )}
                    titleName={
                      testimonialsDetailsData &&
                      testimonialsDetailsData.postedDate
                        ? moment(
                            testimonialsDetailsData &&
                              testimonialsDetailsData.postedDate
                          ).format("DD-MM-YYYY")
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.testimonialPersonalInfo.riderNoteLabel",
                      "Rider Note"
                    )}
                    titleName={
                      testimonialsDetailsData &&
                      testimonialsDetailsData.description
                        ? testimonialsDetailsData.description
                        : "N/A"
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.testimonialPersonalInfo.mediaHeading",
                        "Media"
                      )}
                    </span>
                  </h2>
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <div className="image_heading">
                    {_.get(
                      elements,
                      "euToursElement.testimonialPersonalInfo.thumbnailImageHeading",
                      "Rider Image/Default image (80 x 80 px)"
                    )}
                  </div>
                  {testimonialsDetailsData &&
                  testimonialsDetailsData.image &&
                  testimonialsDetailsData.image.images &&
                  testimonialsDetailsData.image.images[0] &&
                  testimonialsDetailsData.image.images[0].srcPath ? (
                    <img
                      className="image_bikeman"
                      src={`${config.imageBaseUrl}/${testimonialsDetailsData &&
                        testimonialsDetailsData.image &&
                        testimonialsDetailsData.image.images &&
                        testimonialsDetailsData.image.images[0] &&
                        testimonialsDetailsData.image.images[0].srcPath}
                    `}
                      onClick={(e) =>
                        handlePreviewImages(
                          e,
                          testimonialsDetailsData.image &&
                            testimonialsDetailsData.image.images &&
                            testimonialsDetailsData.image.images[0]
                        )
                      }
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                  <div className="d-flex justify-content-center align-items-center mt-n5">
                    {usertype &&
                      (usertype === "EU Tours Admin" || usertype === "Admin") &&
                      testimonialsDetailsData &&
                      testimonialsDetailsData.image &&
                      testimonialsDetailsData.image.images &&
                      (testimonialsDetailsData.image.images[0]
                        .moderationStatus === "PENDING" ||
                        testimonialsDetailsData.image.images[0]
                          .moderationStatus === "APPROVED") && (
                        <img
                          className="image_gallery"
                          alt="close"
                          src={CrossIcon}
                          onClick={() => {
                            setRejectImage(true);
                            setRejectionReasonToggle(!rejectionReasonToggle);
                          }}
                        />
                      )}
                    {usertype &&
                      (usertype === "EU Tours Admin" || usertype === "Admin") &&
                      testimonialsDetailsData &&
                      testimonialsDetailsData.image &&
                      testimonialsDetailsData.image.images &&
                    (testimonialsDetailsData.image.images[0]
                        .moderationStatus === "PENDING" ||
                        testimonialsDetailsData.image.images[0]
                          .moderationStatus === "REJECTED") && (
                          <img
                            className="image_gallery"
                            alt="tick"
                            src={TickIcon}
                            onClick={() => handleApproveImage()}
                          />
                        )}
                  </div>
                </Col>
              </Row>

              {usertype &&
                (usertype === "EU Tours Admin" || usertype === "Admin") && (
                  <div className="d-flex justify-content-center justify-content-between position-relative mt-3">
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.testimonialPersonalInfo.rejectAllLabel",
                        "Reject All"
                      )}
                      customClass={"btn-outline-dark bg-none btnthemeColor"}
                      customClick={() => {
                        setRejectImage(true);
                        setRejectionReasonToggle(!rejectionReasonToggle);
                      }}
                    />
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.testimonialPersonalInfo.acceptAllLabel",
                        "Accept All Images"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() => handleApproveImage()}
                    />
                  </div>
                )}
              <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-5">
                {(usertype === "EU Tours Admin" || usertype === "Admin") && (
                  <CustomButton
                    customType={"button"}
                    name={_.get(
                      elements,
                      "euToursElement.testimonialPersonalInfo.backLabel",
                      "Back"
                    )}
                    customClass={"btn-outline-dark bg-none btnthemeColor"}
                    customClick={() => handleGoBack()}
                  />
                )}
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") &&
                  testimonialsDetailsData &&
                  (testimonialsDetailsData.moderationStatus === "PENDING" ||
                    testimonialsDetailsData.moderationStatus ===
                      "APPROVED") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.testimonialPersonalInfo.rejectLabel",
                        "Reject"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() =>
                        setRejectionReasonToggle(!rejectionReasonToggle)
                      }
                    />
                  )}
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") &&
                  testimonialsDetailsData &&
                  (testimonialsDetailsData.moderationStatus === "PENDING" ||
                    testimonialsDetailsData.moderationStatus ===
                      "REJECTED") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.testimonialPersonalInfo.approveLabel",
                        "Approve"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() => handleApprove()}
                    />
                  )}
              </div>
            </CardBody>
          </Card>
        </Form>
        <Modal isOpen={rejectionReasonToggle} backdrop={true} centered={true}>
          <ModalHeader
            toggle={() => {
              setRejectionReasonToggle(!rejectionReasonToggle);
              setRejectionReason("");
            }}
          >
            {_.get(
              elements,
              "euToursElement.testimonialPersonalInfo.rejectionReasonHeading",
              "Rejection Reason"
            )}
          </ModalHeader>
          <ModalBody>
            <InputText
              inputType={"textarea"}
              inputName={"rejectionReason"}
              customValue={rejectionReason}
              customOnChange={(e) => setRejectionReason(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            {rejectImage === false ? (
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "euToursElement.testimonialPersonalInfo.rejectLabel",
                  "Reject"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                customClick={(e) => handleReject(e)}
              />
            ) : (
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "euToursElement.testimonialPersonalInfo.rejectLabel",
                  "Reject"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                customClick={(e) => handleRejectImage(e)}
              />
            )}
          </ModalFooter>
        </Modal>
        <Modal size="m" centered isOpen={previewImage}>
          <ModalHeader toggle={handlePreviewImages} className="dotted_Heading">
            {imageDetail &&
              imageDetail.srcPath.slice(
                imageDetail.srcPath.lastIndexOf("/") + 1
              )}
          </ModalHeader>
          <ModalBody>
            <div>
              <>
                <img
                  src={`${config.imageBaseUrl}/${imageDetail &&
                    imageDetail.srcPath}`}
                  className="w-100"
                />
                {console.log("name", imageDetail)}
              </>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
}
